import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { destinationFrom } from "../redirect";

/**
 * `/auth/login` for someone who already has a session. Mailed links carry a
 * `redirect`, so honour it instead of dropping everyone on the dashboard.
 */
export function RedirectAfterLogin() {
    const [searchParams] = useSearchParams();

    return <Navigate replace to={destinationFrom(searchParams.get("redirect"))} />;
}
